import React from 'react'
import { useSelector } from 'react-redux'

/**
 * Display or not if module is active
 * @param {React.Component} Component
 * @param {string} rolName
 *
 * @returns {React.Component}
 */
function withRolesAccess(Component, rolName) {
  function Display(props) {
    const rolePermissions = useSelector((store) => store.rolePermissions[rolName])

    if (!rolePermissions) return null
    return <Component {...props} />
  }

  return Display
}

export default withRolesAccess